export default "__VITE_ASSET__SwTdCDfq__"